import { Form, Input } from "antd";
import React from "react";

const DeviceMacAddress: React.FC = () => {
  return (
    <Form.Item
      name="macAddress"
      label="Mac Address"
      rules={[
        {
          required: true,
          message: "Please enter the MAC address",
        },
        {
          pattern:
            /^([0-9A-Fa-f]{2}([-:])){5}[0-9A-Fa-f]{2}$|^[0-9A-Fa-f]{4}\.[0-9A-Fa-f]{4}\.[0-9A-Fa-f]{4}$/,
          message: "Please enter a valid MAC address",
        },
      ]}
    >
      <Input />
    </Form.Item>
  );
};

export default DeviceMacAddress;
